import type { Modes } from 'modes/config/types';

/**
 * Dynamically import a mode.
 */
export async function getMode(mode: Modes.Types): Promise<Modes.CreateMode.Module> {
  return import(`../${mode.toLowerCase()}/index.ts`);
}
